var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 247,
    viewBox: "0 0 423 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 246.958,
    rx: 10,
    fill: "#F22B5D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2680_113812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 423,
    height: 247
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 246.828,
    rx: 10,
    fill: "#F22B5D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2680_113812)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.7917,
    cy: 256.785,
    r: 59.8229,
    fill: "#E7184C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.672,
    cy: -48.4531,
    r: 152.148,
    fill: "#E9174C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.957,
    cy: 235.138,
    r: 115.869,
    stroke: "#BE0F3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.957,
    cy: 235.138,
    r: 87.536,
    stroke: "#BE0F3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.957,
    cy: 235.138,
    r: 59.2026,
    stroke: "#BE0F3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkCard);
export default __webpack_public_path__ + "static/media/pinkCard.8f665c51ac1a2f064b61633c04aed998.svg";
export { ForwardRef as ReactComponent };